import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-success-approved-dialog',
  templateUrl: './success-approved-dialog.component.html',
  styleUrls: ['./success-approved-dialog.component.css'],
})
export class SuccessApprovedDialogComponent implements OnInit {
  constructor(private dialog: MatDialog) {}

  ngOnInit(): void {}
  close() {
    this.dialog.closeAll();
  }
}
